import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { MedicalFeePrePaymentSearchItem } from '../../../model/medical-fee/medical-fee-pre-payment-search-item';
import { IFilterResponse, SearchFilter } from '../../../infrastructure/ifilter-component';
import { MatTableDataSource } from '@angular/material';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-medical-fee-pre-payment-search',
  templateUrl: './medical-fee-pre-payment-search.component.html',
  styleUrls: ['./medical-fee-pre-payment-search.component.css']
})
export class MedicalFeePrePaymentSearchComponent implements OnInit {

  displayedColumns: string[] = ['number', 'physician', 'amount', 'star'];
  dataSource = new MatTableDataSource([]);
  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];

  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor( private menuService: MenuService,
               private route: Router ) {
    this.menuService.setMenuTitle('Honorarios', 'Generar liquidación');
  }

  ngOnInit() {
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch( response: IFilterResponse<MedicalFeePrePaymentSearchItem> ) {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
    this.loading = false;
  }

  onStartSearch() {
    this.loading = true;
  }

  medicalFeePayment( item: MedicalFeePrePaymentSearchItem ) {
    this.route.navigate(['medical-fee-payment', item.Id ]);
  }
}
